import {Button, Form, Row, Select, Space, Spin, Typography, Upload} from "antd";
import {shoppingService} from "api";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import {useAppSelector} from "redux/hooks";
import {Notification} from "components/common";
const ModalUpload = props => {
  const {closeModal} = props;
  const [file, setFile] = useState<any>();
  const {fetchAllFiles, id} = props;
  const {Option} = Select;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const {isModalOpen} = useAppSelector(state => state.common);
  useEffect(() => {
    setFile(null);
    form.setFieldValue("fileType", 1);
  }, [isModalOpen]);
  const handleUpload = async file => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", form?.getFieldValue("fileType"));
      formData.append("idDeNghi", id);
      await shoppingService.uploadChungTu(formData);
      fetchAllFiles(id);
      closeModal();
      Notification("success", "Tải hồ sơ thành công");
    } catch (error) {
      Notification(
        "error",
        error?.response?.data ?? "Đã có lỗi khi tải lên hồ sơ"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const uploadProps = {
    beforeUpload: file => {
      setFile(file);
      return false;
    },
    accept: ".pdf,.xlxs,.xls",
    fileList: [],
  };

  return (
    <Spin spinning={isLoading}>
      <Space>
        <div>Chọn loại hồ sơ:</div>
        <Form form={form}>
          <Form.Item name="fileType">
            <Select
              style={{width: 200}}
              defaultValue={1}
              onChange={() => {
                console.log(form.getFieldsValue());
              }}
            >
              <Option value={1}>Hóa đơn</Option>
              <Option value={2}>Hợp đồng</Option>
              <Option value={3}>Biên bản giao nhận</Option>
              <Option value={4}>Chứng từ khác</Option>
            </Select>
          </Form.Item>
        </Form>
      </Space>
      <div style={{marginTop: 8}}>
        <Space>
          <div>Hồ sơ:</div>
          <Typography.Text strong>
            {file?.name ?? "Chưa chọn Hồ sơ"}
          </Typography.Text>
        </Space>
      </div>

      <Row justify={"end"}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>
          <Upload {...uploadProps}>
            <Button className="btn-sub" icon={<Icons.upload></Icons.upload>}>
              Chọn hồ sơ
            </Button>
          </Upload>

          <Button
            disabled={!file}
            type="primary"
            onClick={() => {
              handleUpload(file);
            }}
          >
            Tải lên
          </Button>
        </Space>
      </Row>
    </Spin>
  );
};
export default ModalUpload;
